import { __assign } from "tslib";
import React, { useContext } from 'react';
import { FlagContext } from './FlagContext';
import { isFlagEnabled } from './helpers';
var withFeatureBranch = function (featureToComponentMap) { return function (Component) {
    var DecoratedFC = React.forwardRef(function (props, ref) {
        var flags = useContext(FlagContext);
        var enabled = Object.keys(featureToComponentMap)
            .filter(function (feature) { return isFlagEnabled(flags, feature); })
            .map(function (feature) { return featureToComponentMap[feature]; });
        // use the first one
        var FeatureComponent = enabled.length ? enabled[0] : Component;
        return React.createElement(FeatureComponent, __assign({ ref: ref }, props));
    });
    DecoratedFC.displayName = "withFeatureBranch(".concat(Component.displayName || 'Component', ")");
    return DecoratedFC;
}; };
export default withFeatureBranch;
//# sourceMappingURL=withFeatureBranch.js.map